import merge from 'lodash/merge';
import { configureRefreshFetch, fetchJSON } from 'refresh-fetch';
import { HeaderModal } from 'src/hooks/types';

export interface MaintenanceData {
  text?: string;
}

const TOKEN_NAME = 'blue_token';
const REFRESH_TOKEN_NAME = 'blue_refresh_token';
export const ARRAY_CONTRACT_IDS = 'ARRAY_CONTRACT_IDS';
export const SAVED_CONTRACT_ID = 'SAVED_CONTRACT_ID';


export const saveContractIds = (data: string) => {
  localStorage.setItem(ARRAY_CONTRACT_IDS, data);
};

// Function to fetch an array of strings from local storage
export const fetchContractIds = (): string[] => {
  const data = localStorage.getItem(ARRAY_CONTRACT_IDS);
  return data && data.includes(',') ? data.split(',') : data ? [data] : [];
};


// Function to save a string to local storage for SAVED_CONTRACT_ID
export const saveContractId = (data: string) => {
  localStorage.setItem(SAVED_CONTRACT_ID, data);
};

// Function to fetch the string from local storage for SAVED_CONTRACT_ID
export const fetchSavedContractId = (): string | null => {
  return localStorage.getItem(SAVED_CONTRACT_ID);
};

export const removeSavedContractId = () => {
  localStorage.removeItem(SAVED_CONTRACT_ID);
};

export const takeContractId = (): string | null => {
  return localStorage.getItem(SAVED_CONTRACT_ID) ?? fetchContractIds()[0];
};



export const retrieveToken = () => localStorage.getItem(TOKEN_NAME);
const saveToken = (token: string) => localStorage.setItem(TOKEN_NAME, token);

const clearToken = () => localStorage.removeItem(TOKEN_NAME);
const clearRefreshToken = () => localStorage.removeItem(REFRESH_TOKEN_NAME);

const retriveRefetchToken = () => localStorage.getItem(REFRESH_TOKEN_NAME);
const saveRefreshToken = (token: string) => localStorage.setItem(REFRESH_TOKEN_NAME, token);

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

const fetchJSONWithToken = (url: string, options = {}) => {
  const token = retrieveToken();
  let headers: HeaderModal = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    platform: 'web',
    device: 'web',
    'X-Locale': 'de',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  let optionsWithToken;
  optionsWithToken = merge(options, { headers: headers });

  return fetchJSON(url, optionsWithToken);
};

const shouldRefreshToken = (error: any) => {
  return error.response?.status === 401 && error.body?.message === 'Token has expired.';
};

const refreshToken = () => {
  const token = retrieveToken();
  const refresh_token = retriveRefetchToken();

  const data = {
    refresh_token,
    scope: '',
    access_token: token,
  };
  return fetchJSONWithToken(`${BASE_URL}/refresh-token`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      platform: 'web',
      device: 'web',
      'X-Locale': 'de',
    },
    body: JSON.stringify(data),
  })
    .then((response: any) => {
      saveToken(response.body.data.access_token);
      saveRefreshToken(response.body.data.refresh_token);
    })
    .catch((error: any) => {
      // Clear token and trigger logout
      clearRefreshToken();
      clearToken();

      // Trigger app logout by dispatching a custom event
      window.dispatchEvent(new CustomEvent('token-expired', {
        detail: { error: error.message || 'Token refresh failed' }
      }));

      throw error;
    });
};

let maintenanceHandler: (data: MaintenanceData) => void = () => {};
export const registerMaintenanceHandler = (fn: (data: MaintenanceData) => void) => { maintenanceHandler = fn; };

const fetchWithRefresh = configureRefreshFetch({
  fetch: fetchJSONWithToken,
  shouldRefreshToken,
  refreshToken,
});

const fetch = (url: string, options = {}) =>
  fetchWithRefresh(url, options).catch((error: any) => {
      if (error.response?.status === 503) {
        maintenanceHandler(error.body ?? {});
      }
      throw error;
    });


export { fetch, refreshToken };
